import { render, staticRenderFns } from "./PortalAppBar.vue?vue&type=template&id=21c674a8&scoped=true&"
import script from "./PortalAppBar.vue?vue&type=script&lang=ts&"
export * from "./PortalAppBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c674a8",
  null
  
)

export default component.exports